module.exports = __webpack_public_path__ + "img/hspx_bg@2x.61e8639e.png";